module.exports = __webpack_public_path__ + "img/agricultura.a3c46c3f.svg";